import { render, staticRenderFns } from "./CyberboardR6ConfigSelection.vue?vue&type=template&id=ab01161c&scoped=true&"
import script from "./CyberboardR6ConfigSelection.vue?vue&type=script&lang=js&"
export * from "./CyberboardR6ConfigSelection.vue?vue&type=script&lang=js&"
import style0 from "./CyberboardR6ConfigSelection.vue?vue&type=style&index=0&id=ab01161c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab01161c",
  null
  
)

export default component.exports